import styled from "styled-components";

export const FooterContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.266);
  display: grid;
  color: var(--color-main-text);
  max-width: 1400px;
  margin-inline: auto;
  padding: 20px 30px;
  box-sizing: border-box;
  /* height: 100dvh; */

  border-radius: 10px;
  border: 1px solid var(--color-main-text);

  backdrop-filter: blur(10px) saturate(140%);
  -webkit-backdrop-filter: blur(10px) saturate(140%);

  margin-bottom: 20px;
  h1 {
    font-weight: 500;
  }
  p {
    color: var(--color-main-text);
    margin: 20px 0 0 0 0;
  }

  button {
    background: linear-gradient(90deg, var(--color-main-text), lime);
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
    color: white;
    gap: 10px;
    margin-top: 20px;
    margin-bottom: 50px;
    cursor: pointer;
  }
`;
export const CircleImg = styled.img`
  transform: scaleX(-1);
  max-width: 400px;
  max-height: 400px;
  margin: auto;
`;
export const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-bottom: 50px;
  gap: 40px;
  @media (max-width: 790px) {
    grid-template-columns: 1fr;
  }
`;
